module.exports = require('./src/normalizeWheel.js');



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/~/normalize-wheel/index.js
// module id = 1173
// module chunks = 2